import {createReducer} from "redux-act";
import {FilterPositions} from "modules/enums";

export interface IPosition {
	id: FilterPositions;
	name: string;
}

const initialState: IPosition[] = [
	{
		id: FilterPositions.QB,
		name: "player_pool.position.QB",
	},
	{
		id: FilterPositions.RB,
		name: "player_pool.position.RB",
	},
	{
		id: FilterPositions.WR,
		name: "player_pool.position.WR",
	},
	// {
	// 	id: FilterPositions.Flex,
	// 	name: "player_pool.position.flex",
	// },
	{
		id: FilterPositions.DF,
		name: "player_pool.position.DF",
	},
];

export const positions = createReducer<IPosition[]>({}, initialState);
